import { render, staticRenderFns } from "./ProgramQuestions.vue?vue&type=template&id=6c3d13d6&scoped=true&lang=pug&"
import script from "./ProgramQuestions.vue?vue&type=script&lang=js&"
export * from "./ProgramQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ProgramQuestions.vue?vue&type=style&index=0&id=6c3d13d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3d13d6",
  null
  
)

export default component.exports